import config from '@/app/editor/config';

export const getEmbedAppUrl = (shopDomain: string) => {
  try {
    const appId = config.getEmbedAppId();

    const [shopName] = shopDomain.split('.');

    return `https://admin.shopify.com/store/${shopName}/apps/${appId}/app`;
  } catch (error) {
    return '';
  }
};
